import { Box, Button, Grid, Typography } from "@mui/material";
import BottomBar from "../../components/BottomBar";
import TopBar from "../../components/TopBar"

import wavemindLogo from "../../static/images/logo512.webp"

import { trackPurchase } from "../../util/metaPixel";
import { useEffect } from "react";
import { getPurchaseTracking } from "../../util/api/paymentApi";
import { useParams } from "react-router-dom";

const PaymentSuccess = () => {
  // 

  const { sessionID } = useParams()

  useEffect(() => {
    let active = true;
    let stopTracking = () => {};
    getPurchaseTracking(sessionID).then((result) => {
      if (active && result.data) stopTracking = trackPurchase(result.data);
    }).catch(() => {
      // Analytics availability does not affect a completed checkout.
    });
    return () => { active = false; stopTracking(); };
  }, [sessionID]);

  return <div
    style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "radial-gradient(circle, rgb(204, 204, 214) 0%, rgb(86, 86, 105) 100%)" }}
  >
    <TopBar />
    <Box
      sx={{
        backgroundSize: "cover",
        position: "relative",
        flex: 100,
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        color: "black",
        minHeight: "100vh"
      }}
    >
      <Grid container justifyContent={"center"} sx={{ mt: "-150px", }}>
        <Grid xs={12} md={8}>
          <img alt="WaveMind" src={wavemindLogo} style={{ maxWidth: "128px" }} />
          <Typography
            variant="h2"
            fontSize={30}
            sx={{ fontSize: 30, }}
          >
            Enjoy your new amp sim!
          </Typography>
          <Typography
            variant="h4"
            fontSize={18}
            sx={{ fontSize: 18, }}
          >
            You will receive a license key in your mail shortly.
          </Typography>

          <Box sx={{ mt: 3 }}>
            <Button sx={{ background: "white" }} href="/account#licenses" variant="contained">Go to Licenses</Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
    <BottomBar />
  </div>
}

export default PaymentSuccess;
